<template>
  <div>
    <Head title="Na vlerëso!" />

    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/vleresimet">Vlerësimet</Link>
      <span class="text-indigo-400 font-medium">/</span> {{ review.data.user }}
    </h1>

    <trashed-message v-if="review.data.deleted_at" class="mb-6"> Kjo dërgesë është fshirë nga sistemi. </trashed-message>

    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-8 pr-6 w-full">
            <label class="font-bold">Shitësi</label>
            <p>{{review.data.user}}</p>
          </div>

          <div class="pb-8 pr-6 w-full">
            <label class="font-bold">Shërbimi</label>
            <p>{{review.data.service}}</p>
          </div>

          <div class="pb-8 pr-6 w-full">
            <label class="font-bold">Qytetet</label>
            <p class="mt-5 ">
              <span class="mr-5 px-5 py-1 bg-indigo-100 rounded-md" v-for="city in  review.data.cities ">{{city.name}}</span>
            </p>
          </div>

          <div class="pb-8 pr-6 w-full">
            <label class="font-bold">Nota</label>
            <p>{{review.data.rate}}</p>
          </div>

          <div class="pb-8 pr-6 w-full">
            <label class="font-bold">Sygjerimi</label>
            <p>{{review.data.suggestion}}</p>
          </div>


        </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Select2 from 'vue3-select2-component'
import Multiselect from '@vueform/multiselect'
import TextareaInput from '@/Shared/TextareaInput'
import TrashedMessage from '@/Shared/TrashedMessage'


export default {
  components: {
    TextareaInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Select2,
    Multiselect,
    TrashedMessage
  },
  layout: Layout,
  props: {
    review: Object,
  },
  remember: 'form',
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
